var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-wrapper"},[_c('Checkbox'),_c('router-link',{staticClass:"link",attrs:{"to":{name: 'Home'}}},[_vm._v("Przejdź do notatek")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }